module.exports = __webpack_public_path__ + "img/11.83e6fdc7.png";